import React from 'react';
import { connect } from 'react-redux';
import { setActiveBlock, setHologramPosition, addToSwap } from 'components/collage/CollageSlice.js';

// Components
import {SketchPicker} from 'react-color';

// CSS
import './ColourPicker.css';

class ColourPicker extends React.Component {
  constructor(props) {
    super(props);

  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.colour != this.props.colour;
  }

  render() {
    return (
      <div 
        className="ColourPicker"
        style={{
          border: 'solid 2px ' + this.props.colour
        }}
      >
        <div
          class="ColourPickerCover" 
          onClick={() => this.props.onExit()}
        />
        <SketchPicker 
          color={this.props.colour}
          disableAlpha={true}
          onChangeComplete={
            color => {
              this.props.onPickColour(color.hex);
              this.setState({
                pickedColour: color.hex
              });
            }
          }
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  collage: state.collage
});

export default connect(
  mapStateToProps,
  {setActiveBlock, setHologramPosition, addToSwap}
)(ColourPicker)
